<template>
    <!-- 对账记录 -->
    <div>
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="submitForm" :rules="rules" ref="contrastForm">
               <el-form-item>
                    <el-select size v-model="submitForm.type" clearable placeholder="请选择对账类型">
                        <el-option label="交易对账文件" value="1"></el-option>
                        <el-option label="商户出款对账文件" value="2"></el-option>
                        <el-option label="交易分润对账文件" value="3"></el-option>
                        <el-option label="商户出款分润对账文件" value="4"></el-option>
                        <el-option label="活动分润对账文件" value="5"></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item>
                    <el-select size v-model="submitForm.status" clearable placeholder="请选择对账结果">
                        <el-option label="对账平" value="1"></el-option>
                        <el-option label="对账不平" value="2"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item>
                    <el-date-picker
                        v-model="submitForm.date"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="请选择对账日期"
                    ></el-date-picker>
                </el-form-item>
				<el-form-item>
				    <el-button
				        type="primary"
				        :loading="loading"
				        style="font-size: 12px;"
				        @click="handleSubmit(submitForm)"
				    >下载对账文件</el-button>
				</el-form-item>
              <el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="handleSearch(submitForm)"
                    >查询</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <el-table :data="centerList" size="mini" border style="width: 100%" v-loading="loading">
                <!-- 序号 -->
                <!-- <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    prop="id"
                    label="ID"
                    min-width="80"
                ></el-table-column> -->
                <!-- 对账类型 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="name"
                    label="对账类型"
                ></el-table-column>
                <!-- 对账日期 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="end_time"
                    label="对账日期"
                    width="200"
                ></el-table-column>
				<!-- 下载日期 -->
				<el-table-column
				    header-align="center"
				    align="center"
				    prop="create_time"
				    label="下载日期"
				    width="300"
				></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed="right"
                    label="操作"
                    width="200"
                >
                    <template slot-scope="scope">
                        <el-button type="text" size="small">
                            <el-link
                                :underline="false"
                                type="primary"
                                :href="scope.row.file_url"
                                target="_blank"
                                style="font-size:12px"
                            >下载</el-link>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10,20,50,100]"
                :current-page="currentPage"
                :page-size="pageSize"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper"
            ></el-pagination>
        </el-card>
        <!-- <record-info v-if="info.isShow" :info="info" @infoClose="handleCloseInfo"></record-info> -->
    </div>
</template>

<script>
// import recordInfo from './components/contrastRecordDetail';
export default {
    data() {
        return {
			rules: {
			    type: [{ required: true, message: '请选择对账类型', trigger: 'change' }],
			    date: [{ required: true, message: '选择对账日期', trigger: 'blur' }]
			},
			submitForm: {
			    type: '', //1.交易 2.提现
			    date: '',
				page: 1,
				limit: 10
			},
            info: {
                isShow: false,
                row: {}
            },
            searchForm: {
                page: 1,
                limit: 10
            },
            brandList: [],
            centerList: [],
            currentPage: 1, //当前页码
            pageSize: 10, //条数
            total: 0,  //总数
            loading: false
        }
    },
    components: {
        // recordInfo
    },
    mounted() {
        this.getData({
            page: 1,
            limit: 10
        })
    },
    methods: {
        handleSearch(searchFrom) { //搜索
            this.currentPage = 1;
            searchFrom.page = 1;
            this.getData(searchFrom);
        },
        handleInfo(row) { //详情
            this.info.isShow = true;
            this.info.row = row;
        },
        handleCloseInfo() { //关闭详情
            this.info.isShow = false;
            this.info.row = {};
        },
        handleCurrentChange(page) { //当前选中页
            this.currentPage = page;
            this.submitForm.page = page;
            this.submitForm.limit = this.pageSize;
            this.getData(this.submitForm);
        },
        handleSizeChange(limit) { //条数
            this.currentPage = 1;
            this.pageSize = limit;
            this.submitForm.page = 1;
            this.submitForm.limit = limit;
            this.getData(this.submitForm);
        },
		handleSubmit(submitForm) {
		    this.$refs.contrastForm.validate((valid) => {
		        if (valid) {
		            let reqData = {
		                type:submitForm.type,
		                date:submitForm.date,
		            };
		            this.loading = true;
		            this.$api.post('export/acc_file_download', reqData, res => {
		                if (res.code == 0) {
		                    this.$message.success(res.msg);
		                    var link=res.data.url;
		                    window.open(link)
		                } else {
		                    this.$message.error(res.msg);
		                }
		                this.loading = false;
		            });
		        }
		    })
		},
        getData(params) { //获取数据
            this.$api.post("export/acc_file_list", params, res => {
                if (res.code == 0) {
                    let data = res.data;
                    this.total = data.count; //总数
                    this.centerList = res.data.list;
                    //渲染结束后取消加载
                } else {
                    this.$message.error(res.msg);
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
</style>